import { Theme } from "@mui/material";
import { makeStyles } from "tss-react/mui";

export const useEmploymentSectionStyles = makeStyles()((theme: Theme) => ({
  card: {
    boxShadow: "0 0 10px rgb(0 0 0 / 0.3)",
    borderRadius: "1rem",
  },
  sectionTitle: {
    textAlign: "start",
    color: theme.palette.info.dark,
    textTransform: "uppercase",
    fontWeight: "bold",
    marginBottom: "1rem",
  },
  inputContainer: {
    marginBottom: "1rem",
  },
  inputTitle: { fontWeight: "bold", color: theme.palette.info.dark, textAlign: "start" },
  radioButton: {
    "&.MuiRadio-root": {
      color: theme.palette.info.dark,
    },
    "&.Mui-checked": {
      color: theme.palette.info.dark,
    },
  },
  radioButtonTitle: {
    color: theme.palette.info.dark,
  },
  checkboxLabel: {
    textAlign: "start",
    "& .MuiFormControlLabel-label": {
      color: theme.palette.info.dark,
    },
  },
  checkbox: {
    color: theme.palette.primary.main,
    "&.Mui-checked": {
      color: theme.palette.primary.main,
      "& svg": {
      color: theme.palette.info.dark,
    }
    },
    
  },
}));
